module.exports = __webpack_public_path__ + "img/28.86843025.png";